(function($, undefined) {
	
	'use strict';
    // Create a Stripe client.
    var validateForm = function () {
        var stripe = ($("html").attr("data-is-dev") === 'true') ? Stripe('pk_test_51S0NUd2Q7oHUVblcFOC18jPIUOk2UTNZNIEZEP1vedvBL6tqJJvZpcCqVzTrDgemv1n8dSNwwFJnCavcZn8beNrx00cxAVM14X') : Stripe($('#stripe-cc-form2').attr('data-key'));
        var button = $('.get-stripe-intent');
        var cardInputsCtn = button.closest('form').find('.card-inputs-inner');
        var cardErrorsId = "card-errors";
        var ccFieldsId = "#stripe-cc-form2";
        var ccFields = $(ccFieldsId);
        var form = button.closest(".submit-after-validation-form");
        var style = JSON.parse($(ccFieldsId).data('style'));
        
        if (ccFields.length !== 0) {
            // Create an instance of Elements.
            var elements = stripe.elements();

            //// Create an instance of the card Element. Remove hidePostalCode if PC validation required
            var card = elements.create('card', {
                hidePostalCode: true, style});

            card.mount(ccFieldsId);

            // Handle real-time validation errors from the card Element.
            card.addEventListener('change', function (event) {
                var displayError = document.getElementById(cardErrorsId);
                if (event.error) {
                    displayError.textContent = event.error.message;
                    button.addClass('disabled');
                } else {
                    displayError.textContent = '';
                    button.removeClass('disabled');
                }
            });

            button.on('click', function (event) {
                event.preventDefault();

                button.addClass('disabled');

                // Send AJAX request to create PaymentIntent
                $.ajax({
                    url: '/action/stripeIntent',
                    method: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        amount: $('input[name="amount"]').val()
                    }),
                    success: function (data) {
                        if (!data.clientSecret) {
                            var errorElement = document.getElementById(cardErrorsId);
                            errorElement.textContent = "Could not initiate payment.";                               
                            return;
                        }

                        stripe.confirmCardPayment(data.clientSecret, {
                            payment_method: {
                                card: card
                            }
                        }).then(function (result) {
                            if (result.error) {
                                document.getElementById(cardErrorsId).textContent = result.error.message;
                            } else if (result.paymentIntent && result.paymentIntent.status === 'succeeded') {
                               $('input[name=cardToken]').val(result.paymentIntent.id);
                                
                                button.closest('form').submit();
                            }
                        });

                    },
                    error: function (xhr, status, error) {
                        var errorElement = document.getElementById(cardErrorsId);
                        errorElement.textContent = error.message;
                        button.removeClass('disabled');
                    }
                });
            });
        }
    };

	Fw.component.export('stripeIntent', {
		init: validateForm
	});

})(jQuery);